const StockMarket = () => {
  return <div>Berze</div>
}

export default StockMarket
